module.exports = __webpack_public_path__ + "img/fWRKHHso.4ed905c5.svg";